{
  "setupWorkplaceStep": {
    "title": "Let’s set up your workplace!",
    "description": "You need to complete next three steps to create a workplace",
    "pill": {
      "setupNow": "Setup now"
    },
    "options": {
      "sso": {
        "title": "Connect your SSO",
        "description": "Set up single sign-on to manage access for your organization.",
        "tooltipTitle": "Help text",
        "buttonLabel": "Manage"
      },
      "orgChat": {
        "title": "Connect your org chart",
        "description": "Import your organization structure to enable automated workflows.",
        "tooltipTitle": "Help text",
        "buttonLabel": "Configure"
      },
      "communicationTool": {
        "title": "Connect communication tool",
        "description": "Collect employee’s feedback with your team’s communication platforms.",
        "tooltipTitle": "Help text",
        "buttonLabel": "Configure"
      },
      "billing": {
        "title": "Setup billing",
        "description": "Add your billing information and choose a plan that fits your needs.",
        "tooltipTitle": "Help text",
        "buttonLabel": "Configure"
      }
    }
  },
  "connectSsoStep": {
    "title": "Connect your SSO provider",
    "description": "Set up single sign-on to manage access for your organization",
    "backButton": "Go back to setup",
    "options": {
      "domain": { "title": "Verify organization domain", "buttonLabel": "Verify" },
      "provider": { "title": "Configure identity provider", "buttonLabel": "Configure" }
    }
  },
  "connectOrgChatStep": {
    "title": "Connect your Org Chart",
    "description": "Import your organization structure to enable automated workflows",
    "backButton": "Go back to setup",
    "options": {
      "workday": { "title": "Workday", "buttonLabel": "Connect" },
      "bamboo": { "title": "BambooHR", "buttonLabel": "Connect" }
    }
  },
  "connectCommunicationToolStep": {
    "title": "Connect your communication tool",
    "description": "All daily questions will be collected from communication tool you use",
    "backButton": "Go back to setup",
    "options": {
      "slack": { "title": "Slack", "buttonLabel": "Connect" },
      "teams": { "title": "Microsoft Teams", "buttonLabel": "Connect" }
    }
  },
  "billingStep": {},
  "alertDialog": {
    "trigger": "Set up later",
    "title": "Do you want to skip setup?",
    "description": "Skipping the setup means you'll need to configure your workplace later. Some features may be unavailable until setup is complete.",
    "actionButton": "Continue setup",
    "cancelButton": "Skip setup"
  }
}
